import {config} from "../../../constants/config";

export default {
  listSshKeyDO: [],
  totalSshKeyDO : 1,
  currentPage : 1,
  per_page : 10
}



// WEBPACK FOOTER //
// ./src/store/digital-ocean/moduleSshKey/state.js